import cn from 'classnames';
import { Icon } from '@nespresso-design-system/components';
import styles from './VertuoOversizedCapsuleCompatibilitySection.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import { hasOversizedCapsule } from '@/domain/Product';
import type { Product } from '@/domain/Product';

export type VertuoOversizedCapsuleCompatibilitySectionProps = {
  class?: string;
  product: Product;
};

export default function VertuoOversizedCapsuleCompatibilitySection({
  class: className,
  product
}: VertuoOversizedCapsuleCompatibilitySectionProps) {
  const { t } = useTranslations();
  const showCompatibilityNotice = hasOversizedCapsule(product.categories);

  if (!showCompatibilityNotice) {
    return null;
  }

  const vertuoOversizedCapsuleCompatibilityLabel = t(
    'productList.machineCompatibility.vertuoOversizedCapsuleCompatibilityLabel'
  );

  return (
    <section className={cn(styles.container, className)}>
      <Icon
        className={styles.icon}
        icon="24/symbol/status-alert"
        method="image"
      />
      {vertuoOversizedCapsuleCompatibilityLabel}
    </section>
  );
}
